define(function (require) {
    var $ = require("jquery");
    var dataLayerService = require("@modules/services/dataLayerService");
    var analyticsCommunicationTypes = {
        Paper: "all paper",
        Electronic: "all electronic",
        Mixed: "mixed"
    };
    var communicationMode = analyticsCommunicationTypes.Mixed;
    var commPreferenceChanged = false;

    $("#communicationPreferencesSubmit").click(function (e) {
        e.preventDefault();

        $("form#notificationPreferencesForm").submit();
    });

    $("#collapseGroup.saveCommPreference").submit(function (e) {
        var dataLayerEvent = {
            event: "preferencesSuccess",
            "communication-type": communicationMode
        };

        dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);

        var $smsEnabled = $("input[type='checkbox'][data-sms='true']:checked");

        $smsEnabled.each(function (input) {
            var dataLayerEvent = {
                event: "textMessage",
                communicationName: $(this).data("communication-name")
            };

            dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
        });
    });

    var setSelectAllOptionField = function (channel, analyticsCommType) {
        $("#collapseGroup.saveCommPreference #OptInAllOption").val(channel);
        communicationMode = analyticsCommType;
    };

    var undoSaveAllCommunicationType = function () {
        setSelectAllOptionField(null, analyticsCommunicationTypes.Mixed);
    };

    var setUndoInputHandlers = function () {
        $("#collapseGroup.saveCommPreference input[type='checkbox'], #collapseGroup.saveCommPreference input[type='radio']").change(undoSaveAllCommunicationType);
    };

    $(document).ready(function () {
        if (($("#communication").length > 0 || $(".communication-pref").length > 0) && window.scan && window.scan.commpreference) {
            var allInputsSelector = "#collapseGroup.saveCommPreference .option input";
            var electricOptionIdentifier = "#collapseGroup.saveCommPreference input[id$='" + window.scan.commpreference.electronicChannelIdentifier + "']:not([disabled])";
            var paperOptionIdentifier = "#collapseGroup.saveCommPreference input[id$='" + window.scan.commpreference.paperChannelIdentifier + "']:not([disabled])";
            // var optOutOptionIdentifier = "#collapseGroup.saveCommPreference input[id$='" + window.scan.commpreference.optOutChannelIdentifier + "']:not([disabled])";

            $("#optin-email").click(function (e) {
                e.preventDefault();
                console.log("optin-email");
                commPreferenceChanged = true;
                // uncheck all checkboxes that are not disabled, except for sms
                $(allInputsSelector).attr("disabled", false).not("[data-sms]").prop("checked", false);
                $(electricOptionIdentifier).prop("checked", true);
                setSelectAllOptionField(window.scan.commpreference.optInOptionsEnum.Electronic, analyticsCommunicationTypes.Electronic);
                setUndoInputHandlers();

                var dataLayerEvent = {
                    event: "setPreference",
                    "ctaTopic": "online",
                    "ctaLink": $(this).text().trim()
                };
                dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
            });

            $("#optin-mail").click(function (e) {
                e.preventDefault();
                console.log("optin-mail");
                commPreferenceChanged = true;
                // uncheck all checkboxes that are not disabled, except for sms
                $(allInputsSelector).attr("disabled", false).not("[data-sms]").prop("checked", false);
                $(paperOptionIdentifier).prop("checked", true);
                setSelectAllOptionField(window.scan.commpreference.optInOptionsEnum.Paper, analyticsCommunicationTypes.Paper);
                setUndoInputHandlers();

                var dataLayerEvent = {
                    event: "setPreference",
                    "ctaTopic": "mail",
                    "ctaLink": $(this).text().trim()
                };
                dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
            });

            $("input.opt-out:checked").each(function () {
                $(this).closest(".communications-options").find(".option input").not(this).removeProp("checked").attr("disabled", true);
            });
        }
    });

    $('.communication-table input[type="checkbox"]').on("click", function () {
        if ($(this).attr("data-bs-toggle")) {
            $(this).prop("checked", false);
        }
        if ($(this).is(".opt-out")) {
            if ($(this).is(":checked")) {
                $(this).closest(".communications-options").find(".option input").not(this).removeProp("checked").attr("disabled", true);
            } else {
                $(this).closest(".communications-options").find(".option input").not(".locked").attr("disabled", false);
            }
            $(this).attr("disabled", false);
        }
    });

    $(".communication-table-container .heading").on("click", "a[aria-expanded='true']", function (e) {
        $(this).removeClass("data-gtm-closeAccordion").addClass("data-gtm-openAccordion");
    });

    $(".communication-table-container .heading").on("click", "a[aria-expanded='false']", function (e) {
        $(this).removeClass("data-gtm-openAccordion").addClass("data-gtm-closeAccordion");
    });

    $(function () {
        $(".communication-table-container .heading a[aria-expanded='false']").addClass("data-gtm-openAccordion");
        $(".communication-table-container .heading a[aria-expanded='true']").addClass("data-gtm-closeAccordion");
    });

    var commPreferenceContainer = $("#communication");
    if (commPreferenceContainer.length) {
        var warnElements = $(".profile-preference")
            .find("input, textarea, select")
            .not(".ignore-warn")
            .not(function () {
                return $(this).parents(".ignore-warn").length > 0;
            });

        warnElements.on("change", function (el) {
            console.log(el);
            commPreferenceChanged = true;
        });

        $("#tabNavLinks a, .back, .header-logo a, #mainNav a").on("click", function (event) {
            if (commPreferenceChanged) {
                event.preventDefault();
                var locationTarget = $(event.target).closest("a").attr("href");

                if ($("#msamUnsavedChanges").length !== 0) {

                    $("#msamUnsavedChanges").modal("show");
                    $("#msamUnsavedChangesYes").attr("href", locationTarget);

                    $("#msamUnsavedChangesNo").on("click", function (e) {
                        $("#msamUnsavedChanges").modal("hide");
                    });
                }
                else {
                    window.location.href = locationTarget;
                    return false;
                }
            }
        });
    }

    //$(".gtm-datalayer").click(function (e) {
    //    var eventName = $(this).attr("data-gtm-event");
    //    var topic = $(this).attr("data-gtm-navTopic");
    //    var subtopic = $(this).attr("data-gtm-subTopic");
    //    var linktext = $(this).attr("data-gtm-navLink") != undefined ? $(this).attr("data-gtm-navLink") : $(this).html();

    //    var dataLayerEvent = {
    //        event: eventName,
    //        "navTopic": topic,
    //        "subTopic": subtopic,
    //        "navLink": linktext
    //    };
    //    dataLayerService.pushEventToGtmDataLayer(dataLayerEvent);
    //});
});
